export { layout } from './layout'
export { scatter } from './types/scatter'
export { bar } from './types/bar'
export { pie } from './types/pie'
export { histogram } from './types/histogram'
export { histogram2d } from './types/histogram2d'
export { violin } from './types/violin'



// WEBPACK FOOTER //
// ./src/index.js